import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Constants from "../utils/Constants";
import { getAccessToken } from "../utils/Auth";
import Notification from "./Notification"
import { epochSeconds, getFileUrls, getStaticFileUrls } from "../utils/Functions";
import { Paper } from '@mui/material'
import { Box, Select, MenuItem, Typography, makeStyles } from '@material-ui/core'
import { Stack, IconButton } from "@mui/material"
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ColumnsDialog from "./ColumnsDialog";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import AnalyzersDialog from "./AnalyzersDialog";
import DeleteDialog from "./DeleteDialog";
import DeployDialog from "./DeployDialog";
import Analyzer from "./Analyzer";
import DeployDialogWindows from "./DeployDialogWindows";
import DeployDialogGDrive from "./DeployDialogGDrive";
import DeployDialogSynology from "./DeployDialogSynology";

let http_str = "https://"
let base_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/analyzers')
let sites_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/sites')
let policies_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/policies')
const access_level = Constants.domainName.endsWith(".com") ? "EA" : "GA" // ransomstop.com -> EA, ransomstop.net -> GA


const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

let headers = [
    { field: 'collapse', headerName: '', width: 50, hidden: false },
    { field: 'seen', headerName: 'Online', width: 50, hidden: false },
    { field: 'pk', headerName: 'Name', width: 300, hidden: false },
    { field: 'site_uuid', headerName: 'Site', width: 100, hidden: false },
    { field: 'storage_type', headerName: 'Type', width: 80, hidden: false },
    { field: 'cloud_region', headerName: 'Region', width: 150, hidden: false },
    { field: 'policy_uuid', headerName: 'Policy', width: 200, hidden: false },
    { field: 'log_level', headerName: 'Log Level', width: 50, hidden: true },
    { field: 'created', headerName: 'Created', width: 220, hidden: false},
    { field: 'modified', headerName: 'Modified', width: 220, hidden: false},
    { field: 'edit', headerName: 'Edit', width: 50, hidden: false },
    { field: 'deploy', headerName: 'Deploy', width: 50, hidden: false },
    { field: 'delete', headerName: 'Delete', width: 50, hidden: false },
]

const toastOptions = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}

const getBlankFormData = () => {
    return ({
        pk: '',
        analyzer_ip: '',
        responder_ip: '',
        install_type: 'Standalone',
        platform: 'Windows',
        node_type: 'Standalone',
        analyzer_name: '',
        cloud_region: '',
        size: 'SMALL',
        site_uuid: '',
        aws_account_id: '',
        policy_uuid: '',
        policy_interval: 3600,
        log_level: 'ERROR',
        log_interval: '300',
        sqs_queue: '',
        storage_type: 'SMB',
        send_alerts: false,
        monitored_storage_location: '',
        suspend_user_policy: '',
        policies_deployed: false,
        vpc_id: '',
        vpc_name: '',
        alerts: [],
        listeners: [],
        subnets: [],
    })
}

export default function Lists() {
    const classes = useStyles()
    const [items, setItems] = useState([])
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedRow, setSelectedRow] = useState([null, null])
    const [columnsMode, setColumnsMode] = useState(false)
    const [addMode, setAddMode] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [deployMode, setDeployMode] = useState(false)
    const [deployHref, setDeployHref] = useState('')
    const [deployCfn, setDeployCfn] = useState('')
    const [deployWindowsMode, setDeployWindowsMode] = useState(false)
    const [deployGDriveMode, setDeployGDriveMode] = useState(false)
    const [deploySynologyMode, setDeploySynologyMode] = useState(false)
    const [installerUrl, setInstallerUrl] = useState('')
    const [winInstallerUrl, setWinInstallerUrl] = useState('')
    const [deleteMode, setDeleteMode] = useState(false)
    const [limit, setLimit] = React.useState(10)
    const [pages, setPages] = useState([0])
    const [pageIndex, setPageIndex] = useState(0)
    const [siteData, setSiteData] = useState([])
    const [policyData, setPolicyData] = useState([])
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    // const [requiresSave, setRequiresSave] = useState(false)
    const [formData, setFormData] = useState(getBlankFormData())


    const getItems = async () => {
        let url = base_url
        if (pageIndex !== 0) {
            console.log('fetch page: ' + pages[pageIndex])
            url = url + '?limit=' + limit + '&nextPageKey=' + pages[pageIndex]
        }
        else {
            console.log('fetch page: 0')
            url = url + '?limit=' + limit
        }
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                if (pageIndex === pages.length - 1) {
                    let npk = res.data['nextPageKey']
                    if (npk) {
                        let tmp_arr = pages
                        tmp_arr.push(npk)
                        setPages(tmp_arr)
                    }
                }
                const items = res.data['analyzers'];
                // console.log(items);
                let analyzers = []
                items.forEach(object => {
                    if (object.node_type === 'Analyzer' || object.node_type === 'Standalone' || object.analyzer_name === '') {
                        object.children = []
                        analyzers.push(object)
                        console.log("added analyzer: " + JSON.stringify(object))
                    }
                    else {
                        console.log("adding child analyzer: " + JSON.stringify(object))
                        const obj_parent = object['analyzer_name'] ? object['analyzer_name'] : 'not assigned'
                        const index = analyzers.findIndex(item => item.pk === obj_parent);
                        if (index > -1) {
                            analyzers[index]['children'].push(object)
                        }
                        else {
                            console.log("couldn't find parent, add to top level")
                            analyzers.push(object)
                        }
                    }
                })
                analyzers.sort((a, b) => a.pk.localeCompare(b.pk))
                for (let i = 0; i < analyzers.length; i++) {
                    if (analyzers[i].hasOwnProperty('children')) {
                        let child_array = analyzers[i]['children']
                        child_array.sort((a, b) => a.pk.localeCompare(b.pk))
                    }
                }
                console.log("total analyzers = " + analyzers.length)
                setItems(analyzers)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
                return Promise.reject(err);
            })
    }

    const addItem = async (item) => {
        let url = base_url
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        let params = {
            pk: item.pk,
            install_type: item.install_type,
            platform: item.platform,
            node_type: item.node_type,
            analyzer_name: item.analyzer_name,
            cloud_region: item.cloud_region,
            size: item.size,
            site_uuid: item.site_uuid,
            policy_uuid: item.policy_uuid,
            policy_interval: item.policy_interval,
            log_level: item.log_level,
            log_interval: item.log_interval,
            storage_type: item.storage_type,
            send_alerts: item.send_alerts,
            alerts: item.alerts,
            listeners: item.listeners,
            monitored_storage_location: item.monitored_storage_location,
            sqs_queue: item.sqs_queue,
            suspend_user_policy: item.suspend_user_policy,
            policies_deployed: false,
            vpc_id: item.vpc_id,
            vpc_name: item.vpc_name,
            subnets: item.subnets,
        }
        const toastId = toast.loading('adding Analyzer...', toastOptions)
        await axios
            .post(url, { 'analyzer': params },{ headers: http_headers })
            .then(res => {
                // Add the data submitted back to the local table so it is correct before server side refresh
                params.pk = res.data['pk']
                const epoch = epochSeconds()
                params.created = epoch
                params.modified = epoch
                setItems(items.concat([params]))
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
                // Notification(res.data['msg'], 'info');
                getItems()
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error adding Analyzer: ${err}`, type: "error", isLoading: false, closeButton: true})
                // Notification(`Error: adding new site. ${err}`, 'error');
            })
    }

    const editItem = async (item) => {
        let url = base_url + "/" + item.pk
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        let params = {
            pk: item.pk,
            install_type: item.install_type,
            platform: item.platform,
            node_type: item.node_type,
            analyzer_name: item.analyzer_name,
            cloud_region: item.cloud_region,
            size: item.size,
            site_uuid: item.site_uuid,
            policy_uuid: item.policy_uuid,
            policy_interval: item.policy_interval,
            log_level: item.log_level,
            log_interval: item.log_interval,
            storage_type: item.storage_type,
            send_alerts: item.send_alerts,
            alerts: item.alerts,
            listeners: item.listeners,
            sns_topic_arn: item.sns_topic_arn,
            monitored_storage_location: item.monitored_storage_location,
            sqs_queue: item.sqs_queue,
            suspend_user_policy: item.suspend_user_policy,
            policies_deployed: item.policies_deployed,
            vpc_id: item.vpc_id,
            vpc_name: item.vpc_name,
            subnets: item.subnets,
        }
        const toastId = toast.loading('saving Analyzer...', toastOptions)
        console.log("toastId: " + toastId)
        await axios
            .put(url, { 'analyzer': params },{ headers: http_headers })
            .then(res => {
                console.log(res.data);
                // Add the data submitted back to the local table
                const newItems = [...items]
                let arr_index = items.findIndex(itm => itm.pk === formData.pk)
                if (arr_index !== -1) {
                    newItems[arr_index] = formData
                }
                setItems(newItems)
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
                // Notification(res.data['msg'], 'info');
                forceUpdate()
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error saving: ${err}`, type: "error", isLoading: false, closeButton: true})
                // Notification(`Error updating analyzer. ${err}`, 'error');
            })
    }

    const deleteItem = async (uuid) => {
        let url = base_url + "/" + uuid
        const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        const toastId = toast.loading('deleting Analyzer...', toastOptions)
        await axios
            .delete(url, { headers: headers })
            .then(res => {
                console.log(res.data);
                let items_filtered = items.map((x) => x)
                items_filtered = items_filtered.filter(i => i.pk !== uuid)
                setItems(items_filtered)
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error deleting: ${err}`, type: "error", isLoading: false, closeButton: true})
                return Promise.reject(err);
            })
    }

    const getDetail = async (base_url, obj_type, uuid, setSelection, openDialog) => {
    let url = base_url + "/" + uuid
    const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
    console.log('get: ' + url + ' ' + JSON.stringify(headers))
    await axios
        .get(url, { headers: headers })
        .then(res => {
            const item = res.data[obj_type];
            setSelection(item)
            openDialog(true)
        })
        .catch(err => {
            if (err.response) {
              console.log('bad response from server: ' + err.response)
            } else if (err.request) {
              console.log('no response from server: ' + err.request)
            } else {
              console.log(err)
            }
            Notification(`Error while fetching ${url}. ${err}`, 'error');
        })
    }

    const getSites = async () => {
        let url = sites_url + '?limit=100'
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                const items = res.data['sites'];
                setSiteData(items)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
            })
    }

    const getPolicies = async () => {
        let url = policies_url + '?limit=25'
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        // console.log('headers: ' + JSON.stringify(http_headers))
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                const items = res.data['policies'];
                console.log(items);
                items.unshift({pk: '0', name: ''})
                setPolicyData(items)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
            })
    }


    // PrefetchSelectedRow will fetch list details every row you click
    // It should make loading the edit screen faster, but it might add a lot more API calls
    const prefetchSelectedRow = (uuid) => {
        // console.log("selected row = " + selectedRow)
        if (selectedRow === uuid) {
            // deselect a row if it's already selected
            setSelectedRow(null)
        }
        else {
            setSelectedRow(uuid)
            let item = getItemByPk('items', uuid)
            setSelectedItem(item)
            setFormData(item)
            // getDetail(uuid)
        }
    }

    function getItemByPk(table, pk) {
        // might have over-engineered this, so far only needs items case
        switch (table) {
            case 'items':
                let top_level_result = items.find(i => i.pk === pk)
                if (top_level_result === undefined) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].hasOwnProperty('children')) {
                            // for (let j = 0; j < items[i])
                            let second_level_result = items[i]['children'].find(i => i.pk === pk)
                            if (second_level_result !== undefined) {
                                return second_level_result
                            }
                        }
                    }
                }
                return items.find(i => i.pk === pk)
            case 'sites':
                return siteData.find(i => i.pk === pk)
            case 'policies':
                return policyData.find(i => i.pk === pk)
            default:
                return null
        }
    }

    const handleOpenColumns = () => {
        setColumnsMode(true);
    };

    const handleCloseColumns = () => {
        setColumnsMode(false);
    };

    const handleOpenAdd = () => {
        setFormData(getBlankFormData())
        setAddMode(true);
        console.log("add new analyzer")
    };

     const handleAdd = (fields) => {
        let addData = addItem(formData)
        // check addData for error and notify user
        setAddMode(false)
    }

     const handleCloseAdd = () => {
         setFormData(getBlankFormData())
         setAddMode(false)
    };

    const handleOpenEdit = (e, uuid) => {
        setSelectedRow(uuid)
        console.log("edit " + selectedRow)
        getDetail(base_url, 'analyzer', uuid, setSelectedItem, setEditMode)
        setFormData((prevFormData) => ({...selectedItem, 'pk': uuid}))
    };

    const handleEdit = (fields) => {
        let editData = editItem(formData)
        // check editData for error and notify user
        setEditMode(false)
    }

    const handleCloseEdit = () => {
        setEditMode(false);
    };

    const handleOpenDeploy = (e, uuid, type) => {
        setSelectedRow(uuid)
        if (type === 'S3') {
            getFileUrls(base_url, 'analyzer', 'cloudformation', uuid, setDeployHref, setDeployCfn);
            setDeployMode(true);
            console.log("deploy AWS analyzer")
        }
        else if (type === 'SMB') {
            // getFileUrls(base_url, 'analyzer', 'windows', uuid, setInstallerUrl, setDeployCfn);
            setDeployWindowsMode(true);
            console.log("deploy Windows analyzer")
        }
        else if (type === 'GDrive') {
            getFileUrls(base_url, 'analyzer', 'gdrive', uuid, setInstallerUrl, setDeployCfn);
            setDeployGDriveMode(true);
            console.log("deploy Google Drive analyzer")
        }
        else if (type === 'Synology') {
            // getFileUrls(base_url, 'analyzer', 'synology', uuid, setInstallerUrl, setDeployCfn);
            setDeploySynologyMode(true);
            console.log("deploy Synology analyzer")
        }
    };

    const handleCloseDeploy = () => {
        setDeployMode(false);
        setDeployWindowsMode(false)
        setDeployGDriveMode(false)
        setDeploySynologyMode(false)
    };

    const handleOpenDelete = (e, uuid) => {
        // stopPropagation seems to block selecting and editing a row in 1 click, so remove it if it doesn't cause any other issues
        //e.stopPropagation()
        setSelectedRow(uuid)
        setDeleteMode(true);
        console.log("delete " + selectedRow)
    };

    const handleDelete = (uuid) => {
        deleteItem(uuid)
        setDeleteMode(false);
    };

    const handleCloseDelete = () => {
        setDeleteMode(false);
    };

    const handleLimit = (event) => {
        setLimit(event.target.value);
        setPages([0])
        setPageIndex(0)
    };

    const handlePreviousPage = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1)
        }
    }

    const handleNextPage = () => {
        if (pageIndex < pages.length - 1) {
            setPageIndex(pageIndex + 1)
        }
    }

    const toggleColumn = (event) => {
        for (let i = 0; i < headers.length; i++) {
            if (headers[i]['field'] === event.target.id) {
                headers[i]['hidden'] = !headers[i]['hidden']
            }
        }
        //  ugly but since the checkboxes aren't tied to state, they are tied to column definitions, they don't update
        forceUpdate()
    };

    useEffect(() => {
        getItems()
        getSites()
    }, []);

    useEffect(() => {
        getPolicies()
        getStaticFileUrls(`installers/latest/installer-gui-windows_latest_${access_level}.zip`, setWinInstallerUrl, 'source=global')
    }, [pageIndex, limit] )

    return (
        <div className={classes.outer_div} style={{padding: '20px'}}>
            <Paper className={classes.card} variant="outlined" style={{padding: '15px'}}>
                <Stack direction={"row"} justifyContent={"space-between"}>
                    <Typography variant="h4" >Analyzers</Typography>
                    <Box>
                        <ViewWeekOutlinedIcon className={classes.spaced} color={"primary"}
                                              onClick={() => handleOpenColumns()}/>
                        <AddOutlinedIcon className={classes.spaced} color={"primary"}
                                         onClick={() => handleOpenAdd()}/>
                    </Box>
                </Stack>
                {/* TABLE */}
                <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                    <thead>
                    <tr key={1} className={classes.tableComponent}>
                        {headers.map(header => (
                            <th width={header.width}
                                className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody className={classes.tableComponent}>
                    {items.map(val =>
                        <Analyzer key={val.pk} analyzer={val} headers={headers} siteData={siteData}
                                  policyData={policyData} prefetchSelectedRow={prefetchSelectedRow} handleOpenEdit={handleOpenEdit}
                                  handleOpenDelete={handleOpenDelete} handleOpenDeploy={handleOpenDeploy} winInstallerUrl={winInstallerUrl}/>
                    )}
                    </tbody>
                </table>
                <Paper className={classes.itemBar} elevation={1}>
                    <Stack className={classes.pageBar}
                           elevation={0}
                           direction="row"
                        alignItems="center"
                        sx={{ width: 1, height: "5vh" }} >
                            <IconButton onClick={() => getItems()}><RefreshOutlinedIcon className={classes.spaced} /></IconButton>
                            <Typography className={classes.spaced}>Rows per page:</Typography>
                            <Select
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                labelId="fetch-limit-select"
                                id="fetch-limit-select"
                                name="fetch-limit-select"
                                value={limit}
                                label="Limit"
                                onChange={handleLimit}
                            >
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={25}>25</MenuItem>
                              <MenuItem value={50}>50</MenuItem>
                            </Select>
                            <IconButton disabled={pageIndex === 0} onClick={() => handlePreviousPage()}><ChevronLeftOutlinedIcon /></IconButton>
                            <Typography variant={'h6'}>{pageIndex + 1}</Typography>
                            <IconButton disabled={pageIndex >= pages.length - 1} onClick={() => handleNextPage()}><ChevronRightOutlinedIcon /></IconButton>
                    </Stack>
                </Paper>

                {/* DIALOGS */}
                {/* COLUMNS DIALOG */}
                <ColumnsDialog
                    variant={"outlined"}
                    open={columnsMode}
                    onClose={handleCloseColumns}
                    onChange={toggleColumn}
                    headers={headers}
                />

                {/* ADD DIALOG */}
                <AnalyzersDialog
                    mode={'add'}
                    open={addMode}
                    onClose={handleCloseAdd}
                    onSave={handleAdd}
                    formData={formData}
                    setFormData={setFormData}
                    siteData={siteData}
                    policyData={policyData}
                    analyzerData={items.filter(item => item['node_type'] === 'Analyzer')}
                />

                {/* EDIT DIALOG */}
                <AnalyzersDialog
                    mode={'edit'}
                    open={editMode}
                    onClose={handleCloseEdit}
                    onSave={handleEdit}
                    formData={formData}
                    setFormData={setFormData}
                    siteData={siteData}
                    policyData={policyData}
                    analyzerData={items.filter(item => item['node_type'] === 'Analyzer')}
                />

                {/* DEPLOY DIALOGS */}
                <DeployDialog
                    type={'analyzer'}
                    open={deployMode}
                    onClose={handleCloseDeploy}
                    href={deployHref}
                    cfn={deployCfn}
                    item={formData}
                />
                <DeployDialogWindows
                    open={deployWindowsMode}
                    onClose={handleCloseDeploy}
                    installer_url={installerUrl}
                    item={formData}
                />
                <DeployDialogGDrive
                    type={'analyzer'}
                    open={deployGDriveMode}
                    onClose={handleCloseDeploy}
                    installer_url={installerUrl}
                    item={formData}
                />
                <DeployDialogSynology
                    open={deploySynologyMode}
                    onClose={handleCloseDeploy}
                    item={formData}
                />

                {/* DELETE DIALOG */}
                <DeleteDialog
                    open={deleteMode}
                    onClose={handleCloseDelete}
                    onDelete={handleDelete}
                    formData={formData}
                    setFormData={setFormData}
                    type={'analyzer'}
                    row={selectedRow}
                    item={selectedItem}
                />
            </Paper>
        </div>
    )
}